import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputButtonWrapper = styled.div`
  padding-bottom: ${rem(32)};

  div {
    width: ${rem(215)};
  }
`;

export const InputWrapperOne = styled.div`
  padding-bottom: ${rem(32)};

  div {
    width: ${rem(300)};
  }
`;

export const InputWrapperTwo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-bottom: ${rem(32)};

  div {
    width: ${rem(300)};
  }
`;

export const InputWrapperThree = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-bottom: ${rem(20)};

  div {
    width: ${rem(300)};
  }
`;

export const HorizontalLine = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  padding-bottom: ${rem(18)};
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;

  select {
    width: ${rem(300)};
  }
`;

export const CopyMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-top: 4px;
  padding-bottom: 4px;

  select {
    width: ${rem(300)};
  }
`;
